import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';

@Component({
  selector: 'mkt-currency',
  templateUrl: './mkt-currency.component.html',
  styleUrls: ['./mkt-currency.component.scss', '../../mk-table.comp.scss', '../../mk-table.comp.input.scss'],
  host:{
    "class" : 'mkt_col col-currency',
    // "(click)": '!readonly ? this.setFocus(true) : {}',
    "[class.has-change]": "_hasChange"
  }
})
export class MktCurrencyComponent implements OnInit {

  @Input() value: {currency: string, value: number};
  @Output() valueChange: EventEmitter<string> = new EventEmitter<string>();
  @Input() readonly: boolean;
  
  private _hasChange: boolean = false;
  public focus = false;

  @ViewChild('input', {static: false}) input: ElementRef;

  public setFocus = (focus: boolean) => {this.focus = focus; setTimeout(() => {if(focus) this.input.nativeElement.focus()}, 10);}

  constructor() { }

  ngOnInit(): void {
  }

  // ngOnChanges(): void{this._hasChange = true; setTimeout(() => {this._hasChange = false}, 2000);}

  public emitValue(ev: any){this.valueChange.emit(ev)}

}
